﻿import { Delay } from "../Async";
import { RecordingIndicator } from "./RecordingIndicator";
import { VoiceIndicator } from "./VoiceIndicator";

let mediaRecorder: MediaRecorder;
let blobs: Blob[] = [];
let isStopped: boolean = false;
let Dotnet: any;
let completion: Promise<void>;
let webInterop: any;
let interval: any;
let start: Date;
async function Start(dotnet: any): Promise<boolean> {
    try {
        console.log("dotnet ", dotnet);
        Dotnet = dotnet;

        let wnd: any = window;
        webInterop = wnd.chrome?.webview?.hostObjects?.webInterop;
        if (webInterop != null) {
            webInterop.RecordStart();
            isStopped = false;
            return true;
        }

        blobs = [];
        isStopped = false;

        const stream = await navigator.mediaDevices.getUserMedia({ audio: { channelCount: 1, sampleRate: 16000 } });

        const typesToTry = ['audio/webm;codecs=opus', 'audio/webm', 'audio/mp4', 'audio/mpeg'];

        let mime = '';
        if (MediaRecorder.isTypeSupported) {
            for (const t of typesToTry) if (MediaRecorder.isTypeSupported(t)) { mime = t; break; }
        }

        mediaRecorder = new MediaRecorder(stream, { mimeType: mime, audioBitrateMode: "variable", audioBitsPerSecond: 16000 });

        mediaRecorder.ondataavailable = e => {
            if (e.data && e.data.size > 0) {
                blobs.push(e.data);
            }
        };

        mediaRecorder.onstart = () => {
            completion = Flush();
        };

        mediaRecorder.onstop = async () => {
            setTimeout(() => { isStopped = true; }, 2000);
        };

        // emit chunks every 1 seconds
        RecordingIndicator.Start();
        mediaRecorder.start(1000);
        start = new Date(0);
        StartTimeCount();
        return true;
    } catch (err: any) {
        console.log("Error starting recording: " + err.message);
        return false;
    }
}

function StartTimeCount() {
    interval = setInterval(() => {
        start.setTime(start.getTime() + 500);
        const recordingTime: any = document.getElementById("recordingTime");
        if (start.getUTCHours() > 0) recordingTime.innerText = start.toISOString().substr(11, 8);
        else recordingTime.innerText = start.toISOString().substr(14, 5);
    }, 500);
}

async function Flush() {
    while (!isStopped || blobs.length != 0) {
        if (blobs.length > 0) {
            let b = blobs[0];
            blobs.splice(0, 1);
            const buffer = await b.arrayBuffer();
            Dotnet.invokeMethodAsync("OnAudioStream", new Uint8Array(buffer));
        }
        await Delay(100);
    }
}

async function Stop() {
    if (webInterop != null) {
        webInterop.RecordStop();
        isStopped = true;
        return true;
    }
    mediaRecorder.stop();
    RecordingIndicator.Stop();
    clearInterval(interval);
    const recordingTime: any = document.getElementById("recordingTime");
    recordingTime.innerText = "";
    await completion;
}

async function Pause() {
    if (webInterop != null) {
        webInterop.RecordPause();
        return true;
    }
    RecordingIndicator.Pause();
    mediaRecorder.pause();
    clearInterval(interval);
}

async function Resume() {

    if (webInterop != null) {
        webInterop.RecordResume();
        return true;
    }
    RecordingIndicator.Resume();
    mediaRecorder.pause();
    StartTimeCount();
}

export const VoiceRecorder = {
    Start,
    Pause,
    Resume,
    Stop
}